export class Product {
    name: string;
    sku: string;
    category?: string;
    price: number;
    quantity: number;
}
